/* eslint-disable no-useless-escape */
import Vue from 'vue'
import App from './App.vue'
import config from './config'

import Clipboard from 'v-clipboard'


import router from './router/router'
import store from './store'
import i18n from './utils/vue-i18n'

import hdWallet,{ Tooltip, Modal} from './components'


import './global.css'

import masscafe_share from "masscafe_share";
Vue.use(masscafe_share);

Vue.use(hdWallet)
Vue.use(Clipboard)

Vue.filter('fmoney',function (s,m = 0){
    m = m ? m : ((s+"").split('.')[1] || '').length
    const n = m > 0 && m <= 20 ? m : 0;  
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";  
    var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1] || '';  
    let t = "";  
    for (let i = 0; i < l.length; i++) {  
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");  
    }  
    return t.split("").reverse().join("") + (r ? ("." + r):'');  
})
Vue.filter('textcut',function(s = '',num = 10,pos='center') {
   if(pos === 'left') {
     return s.slice(0,num) + '...'
   }
   if(pos === 'right') {
      return '...' + s.slice(-num) 
  }
    if(pos === 'center') {
      return s.slice(0,num) + '...' + s.slice(-num) 
    }
})
Vue.config.productionTip = false



Vue.prototype.$tooltip = Tooltip
Vue.prototype.$modal = Modal
Vue.prototype.$explorer = config.EXPLORERURL
new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
